import * as React from 'react';
import Form, { Rule } from 'antd/lib/form';
import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import Input from 'antd/lib/input';
import Text, { TextProps } from 'antd/lib/typography/Text';
import FormItem from 'antd/lib/form/FormItem';
import useForm from 'antd/lib/form/hooks/useForm';
import { RunwayUserAction } from '../helpers/aclHelpers';
import PermissionedActionButton from './HOCs/PermissionedActionButton';

interface AppSettingsActionsComponentProps {
    recordId: number | string;
    isEditing: boolean;
    saveIsLoading: boolean;
    saveDisabled: boolean;
    deleteConfirmationText: string;
    saveButtonOnClick: (id: number | string) => void;
    editCancelButtonClicked: (id: number | string) => void;
    editStartButtonClicked: (id: number | string) => void;
    deleteConfirm: (id: number | string) => void;
    editPermissionedActionType?: RunwayUserAction;
    deletePermissionsedActionType?: RunwayUserAction;
}

export const AppSettingsActionsComponent = (props: AppSettingsActionsComponentProps) => {
    let editButton = null;
    let deleteButton = null;

    if (!props.isEditing && props.editPermissionedActionType) {
        editButton = (
            <PermissionedActionButton
                actionType={props.editPermissionedActionType}
                onClick={() => {
                    props.editStartButtonClicked(props.recordId);
                }}
            >
                Edit
            </PermissionedActionButton>
        );
    } else if (!props.isEditing) {
        editButton = (
            <Button
                onClick={() => {
                    props.editStartButtonClicked(props.recordId);
                }}
            >
                Edit
            </Button>
        );
    }

    if (props.deletePermissionsedActionType) {
        deleteButton = (
            <Popconfirm
                placement="topRight"
                title={props.deleteConfirmationText}
                onConfirm={() => props.deleteConfirm(props.recordId)}
            >
                <PermissionedActionButton actionType={props.deletePermissionsedActionType} type="text" danger>
                    Delete
                </PermissionedActionButton>
            </Popconfirm>
        );
    } else {
        deleteButton = (
            <Popconfirm
                placement="topRight"
                title={props.deleteConfirmationText}
                onConfirm={() => props.deleteConfirm(props.recordId)}
            >
                <Button style={{ marginLeft: 6 }} type="text" danger>
                    Delete
                </Button>
            </Popconfirm>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {props.isEditing && (
                <div>
                    <Button
                        type="primary"
                        onClick={() => props.saveButtonOnClick(props.recordId)}
                        loading={props.saveIsLoading}
                        disabled={props.saveDisabled}
                    >
                        Save
                    </Button>
                    <Button
                        style={{ marginLeft: 6 }}
                        onClick={() => {
                            props.editCancelButtonClicked(props.recordId);
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            )}
            {editButton}
            {deleteButton}
        </div>
    );
};

interface AppSettingsEditableInputComponentProps {
    id: number | string;
    isEditing: boolean;
    defaultValue: string;
    textProps?: TextProps;
    rules?: Rule[];
    onValueChanged: (id: number | string, value: string, isValid: boolean) => void;
}

export const AppSettingsEditableInputComponent = (props: AppSettingsEditableInputComponentProps) => {
    const [form] = useForm();

    const onFieldsChange = () => {
        const errors = form.getFieldError('mainInput');
        const value = form.getFieldValue('mainInput');

        props.onValueChanged(props.id, value, errors.length === 0);
    };

    React.useEffect(() => {
        if (!props.isEditing) {
            form.setFieldsValue({ mainInput: props.defaultValue });
        }
    }, [props.isEditing]);

    return (
        <div>
            {props.isEditing && (
                <Form form={form} initialValues={{ mainInput: props.defaultValue }} onFieldsChange={onFieldsChange}>
                    <FormItem name="mainInput" rules={props.rules}>
                        <Input autoComplete="off" />
                    </FormItem>
                </Form>
            )}
            {!props.isEditing && <Text {...props.textProps}>{props.defaultValue}</Text>}
        </div>
    );
};
